module.exports = __webpack_public_path__ + "img/add_icon.1ab3a8ac.svg";